import React, { useEffect } from 'react'
import { Spin } from 'antd'
import PaymentTable from '../../PaymentTable'
import { useDispatch, useSelector } from 'react-redux'
import { fetchApplicationPaymentsAction, paymentsSelector } from '../../../store/payment'

const ApplicationPaymentsDetailView = ({ application }) => {
  const dispatch = useDispatch()

  const { isFetching, applicationPayments } = useSelector(paymentsSelector)

  const loadData = async () => {
    try {
      dispatch(fetchApplicationPaymentsAction(application)).unwrap()
    } catch (err) {
      console.error(err.error)
    }
  }

  useEffect(() => loadData(), [application])

  return (
    <Spin spinning={isFetching}>
      <PaymentTable ds={applicationPayments[application]} refreshHandler={loadData} />
    </Spin>
  )
}

export default ApplicationPaymentsDetailView
